var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 55,
    viewBox: "0 0 85 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 54.9977V44.7139H2.28157V45.836C2.52203 45.3953 2.79791 45.0985 3.11293 44.9435C3.42609 44.7904 3.86414 44.7139 4.42335 44.7139H6.02455V47.1597H3.30306C2.67675 47.1597 2.36173 47.5201 2.36173 48.2426V54.9977H0Z",
    fill: "#00B17E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42641 54.9982C7.69099 54.9982 6.82422 54.0703 6.82422 52.2126V51.21C6.82422 49.6061 7.69845 48.8052 9.44505 48.8052H12.7071V48.2245C12.7071 47.5169 12.3865 47.1622 11.7471 47.1622H7.44494V44.7163H11.7471C13.9094 44.7163 14.9887 45.859 14.9887 48.1442V55.0001H9.42641V54.9982ZM12.709 50.648H9.76753C9.28661 50.648 9.04615 50.9094 9.04615 51.4303V52.0315C9.04615 52.5001 9.28661 52.7335 9.76753 52.7335H12.709V50.648Z",
    fill: "#00B17E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7923 54.9978C17.617 54.9978 16.5303 53.8552 16.5303 51.5699V48.142C16.5303 45.8567 17.617 44.714 19.7923 44.714H22.2529V40.9463H24.6351V54.9978H19.7923ZM22.2547 47.1599H19.8725C19.2313 47.1599 18.9125 47.5146 18.9125 48.2222V51.5101C18.9125 52.2177 19.2331 52.5725 19.8725 52.5725H22.2547V47.1599Z",
    fill: "#00B17E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.417 43.3511V40.9463H28.8179V43.3511H26.417ZM26.417 54.9978V44.714H28.8179V54.9978H26.417Z",
    fill: "#00B17E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8617 54.9977C32.6613 54.9977 31.8001 54.7176 31.2801 54.1556C30.76 53.5936 30.499 52.7049 30.499 51.4894V48.2221C30.499 46.9786 30.7656 46.0843 31.2987 45.5354C31.8318 44.9883 32.6855 44.7139 33.8599 44.7139H35.5207C36.7212 44.7139 37.5823 44.9921 38.1024 45.5466C38.6225 46.1011 38.8834 46.9936 38.8834 48.2221V51.4894C38.8834 52.6657 38.6299 53.5432 38.1229 54.1257C37.6159 54.7064 36.8162 54.9977 35.722 54.9977H33.8617ZM36.5031 48.2015C36.5031 47.507 36.2086 47.1597 35.6232 47.1597H33.7424C33.1683 47.1597 32.8813 47.4809 32.8813 48.1213V51.5286C32.8813 51.8629 32.9484 52.1205 33.0807 52.2997C33.2131 52.4808 33.4349 52.5705 33.7406 52.5705H35.6214C36.2086 52.5705 36.5012 52.2493 36.5012 51.6089V48.2015H36.5031Z",
    fill: "#00B17E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2471 54.9975V52.4546H42.6088V54.9975H40.2471Z",
    fill: "url(#paint0_linear_359_17234)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2523 54.9982C45.077 54.9982 43.9902 53.8556 43.9902 51.5703V48.1834C43.9902 45.872 45.077 44.7163 47.2523 44.7163H50.835V47.1622H47.3119C46.6856 47.1622 46.3706 47.53 46.3706 48.2656V51.5124C46.3706 52.22 46.6838 52.5748 47.3119 52.5748H50.8741V55.0001H47.2523V54.9982Z",
    fill: "#2B3990"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4541 54.9978V40.9463H54.8363V54.9978H52.4541Z",
    fill: "#2B3990"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7983 54.9977C58.5978 54.9977 57.7366 54.7176 57.2166 54.1556C56.6965 53.5936 56.4355 52.7049 56.4355 51.4894V48.2221C56.4355 46.9786 56.7021 46.0843 57.2352 45.5354C57.7683 44.9883 58.6221 44.7139 59.7964 44.7139H61.4572C62.6577 44.7139 63.5189 44.9921 64.0389 45.5466C64.559 46.1011 64.82 46.9936 64.82 48.2221V51.4894C64.82 52.6657 64.5665 53.5432 64.0594 54.1257C63.5524 54.7064 62.7528 54.9977 61.6586 54.9977H59.7983ZM62.4396 48.2015C62.4396 47.507 62.1451 47.1597 61.5598 47.1597H59.679C59.1048 47.1597 58.8178 47.4809 58.8178 48.1213V51.5286C58.8178 51.8629 58.8849 52.1205 59.0172 52.2997C59.1496 52.4808 59.3714 52.5705 59.6771 52.5705H61.5579C62.1451 52.5705 62.4377 52.2493 62.4377 51.6089V48.2015H62.4396Z",
    fill: "#2B3990"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3263 54.9977V53.8755C72.0859 54.3031 71.8118 54.5962 71.5061 54.7568C71.1986 54.9174 70.7587 54.9977 70.1845 54.9977H68.904C67.1965 54.9977 66.3428 53.8812 66.3428 51.65V44.7139H68.684V51.51C68.684 52.2176 68.9636 52.5723 69.5247 52.5723H71.2862C71.6329 52.5723 71.8789 52.4827 72.0262 52.3016C72.1735 52.1205 72.2462 51.8517 72.2462 51.4894V44.7139H74.6079V54.9977H72.3263Z",
    fill: "#2B3990"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4701 54.9978C77.2947 54.9978 76.208 53.8552 76.208 51.5699V48.142C76.208 45.8567 77.2947 44.714 79.4701 44.714H81.9306V40.9463H84.3128V54.9978H79.4701ZM81.9306 47.1599H79.5484C78.9071 47.1599 78.5884 47.5146 78.5884 48.2222V51.5101C78.5884 52.2177 78.909 52.5725 79.5484 52.5725H81.9306V47.1599Z",
    fill: "#2B3990"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3408 37.4663L48.3467 37.4762L48.3408 37.4663Z",
    fill: "url(#paint1_linear_359_17234)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5223 34.875L44.6396 32.1958L46.5223 34.875Z",
    fill: "url(#paint2_linear_359_17234)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4469 26.637L51.2084 28.814C53.7379 26.411 55.3186 23.0149 55.3186 19.2471C55.3186 11.9637 49.4246 6.06006 42.153 6.06006C34.8814 6.06006 28.9873 11.9637 28.9873 19.2471C28.9873 22.3072 30.0312 25.1228 31.7778 27.3595V19.2453C31.7778 18.9409 31.7927 18.6422 31.8188 18.3453C32.2755 13.0279 36.7249 8.85319 42.153 8.85319C47.883 8.85319 52.5282 13.5059 52.5282 19.2453C52.53 22.1373 51.3501 24.7512 49.4469 26.637Z",
    fill: "url(#paint3_linear_359_17234)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1568 0C31.5449 0 22.9424 8.6165 22.9424 19.2457C22.9424 26.0455 26.4673 32.0145 31.7816 35.4369V31.7102C28.2195 28.7322 25.9528 24.255 25.9528 19.2438C25.9528 10.28 33.2076 3.01344 42.1568 3.01344C51.106 3.01344 58.3609 10.28 58.3609 19.2438C58.3609 23.9656 56.3458 28.2169 53.1322 31.1818L55.0317 33.5287C58.9238 30.0074 61.3713 24.9122 61.3713 19.2438C61.3713 8.6165 52.7688 0 42.1568 0Z",
    fill: "url(#paint4_linear_359_17234)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7451 35.9203L49.8904 33.5118L48.004 31.0604L46.2574 28.7919C46.2555 28.7919 46.2555 28.7938 46.2537 28.7938C44.9973 29.3352 43.6123 29.6377 42.1565 29.6377C40.7194 29.6377 39.3512 29.3445 38.106 28.8162V25.364C39.2673 26.1369 40.6578 26.5869 42.1565 26.5869C46.2052 26.5869 49.4859 23.3009 49.4859 19.2456C49.4859 15.1903 46.2052 11.9043 42.1565 11.9043C40.8219 11.9043 39.5711 12.2646 38.4918 12.8882V12.8864C38.4918 12.8864 38.4788 12.8938 38.462 12.905C38.4266 12.9256 38.3595 12.9685 38.27 13.0283C37.9625 13.2224 37.6661 13.4316 37.3921 13.6687C37.3921 13.6687 37.3622 13.6929 37.3138 13.7359C37.2784 13.7676 37.2262 13.8162 37.1684 13.8722C36.8142 14.2027 36.4899 14.5667 36.2047 14.9607C36.1226 15.0652 36.0444 15.1735 35.9661 15.2874C35.4814 15.9857 35.0695 16.824 34.9054 17.7949L34.8271 17.9779V19.2437V19.2456V26.6V30.1997V33.7191V37.0369C35.2111 37.1956 35.6026 37.3393 35.9978 37.4737C36.3184 37.582 36.6446 37.6829 36.9726 37.7743C37.0043 37.7837 37.0342 37.793 37.0658 37.8005C37.2299 37.8453 37.3958 37.8901 37.5635 37.9312C37.735 37.9723 37.9065 38.0133 38.078 38.0507C38.0873 38.0525 38.0967 38.0544 38.106 38.0581V34.9663V31.796C39.3828 32.2086 40.7417 32.4345 42.1565 32.4345C43.0065 32.4345 43.836 32.3505 44.6394 32.1974L46.5202 34.8785L48.3395 37.47L48.3451 37.4793L48.4346 37.4383C49.5735 37.0443 50.664 36.5439 51.6948 35.9521L51.7451 35.9297",
    fill: "url(#paint5_linear_359_17234)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_359_17234",
    x1: 40.2467,
    y1: 53.7258,
    x2: 42.6081,
    y2: 53.7258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00236684,
    stopColor: "#00B17E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3192"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_359_17234",
    x1: 48.3414,
    y1: 37.4708,
    x2: 48.3476,
    y2: 37.4708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36368C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0955,
    stopColor: "#353F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2755,
    stopColor: "#30538E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    stopColor: "#27708E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8186,
    stopColor: "#159787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9976,
    stopColor: "#00B17E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B17E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_359_17234",
    x1: 44.6401,
    y1: 33.5356,
    x2: 46.5217,
    y2: 33.5356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36368C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0955,
    stopColor: "#353F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2755,
    stopColor: "#30538E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    stopColor: "#27708E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8186,
    stopColor: "#159787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9976,
    stopColor: "#00B17E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B17E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_359_17234",
    x1: 45.3086,
    y1: 31.0471,
    x2: 39.0057,
    y2: 7.53252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36368C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0955,
    stopColor: "#353F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2755,
    stopColor: "#30538E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    stopColor: "#27708E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8186,
    stopColor: "#159787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9976,
    stopColor: "#00B17E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B17E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_359_17234",
    x1: 45.3104,
    y1: 31.0476,
    x2: 39.0076,
    y2: 7.53298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36368C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0955,
    stopColor: "#353F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2755,
    stopColor: "#30538E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    stopColor: "#27708E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8186,
    stopColor: "#159787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9976,
    stopColor: "#00B17E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B17E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_359_17234",
    x1: 43.213,
    y1: 31.6096,
    x2: 36.9102,
    y2: 8.09498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36368C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0955,
    stopColor: "#353F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2755,
    stopColor: "#30538E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    stopColor: "#27708E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8186,
    stopColor: "#159787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9976,
    stopColor: "#00B17E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B17E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRCloud);
export default __webpack_public_path__ + "static/media/rCloud.ac572d82708f5d183a26908de82ce5ef.svg";
export { ForwardRef as ReactComponent };